import { EditCompanyCreationRequest } from '@bupa-kkv/features/company-creation/types';
import { queryKeyStore } from '@bupa-monorepo/shared-frontend/query-key-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editCompanyCreations } from '../../api/single-person/edit-company-creations';

export const useEditCompanyCreations = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: EditCompanyCreationRequest) =>
      editCompanyCreations(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeyStore.companyCreation.companyCreations.queryKey,
      });
    },
  });
};
